import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const branchZipcode = async (branchID, isActive) => {
  const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.branchZipcode(branchID, isActive)}`;
  const res = await fetch(url);

  if (!res.ok) {
    return { error:true, message: 'Branch Zipcode request failed', status: res.status, data: [] };
  }
  const getData = await res.json();
  return { status: res.status, data: getData };
};

export default branchZipcode;
